S.formCompetition =
  {
      elements: {
          $additionalInfoText: null,
          $textareaCount: null,
          $filepondhidden: null,
      },

      /** @var {jQuery|Object} $textarea */
      $textarea: null,

      init()
      {
          this.$module.on('submit', (event) =>
          {
              sessionStorage.setItem('scrollToCompetition', '1');
           });
          this.getFieldPond();
          this.$textarea = this.elements.$additionalInfoText.find('textarea');
          this.$textarea.on('keyup', (e) =>
          {
              const currentLength = e.currentTarget.value;

              this.elements.$textareaCount.html(this.$textarea.val());
              // init event
              this.elements.$textareaCount.html(currentLength.length);
          });
      },

      /**
     * give the user a response of how long the text is
     */
      initTextareaEvent()
      {
          this.$textarea.on('keyup', (e) =>
          {

          });
      },
      getFieldPond()
      {
          const allowedExtensions = /(\.doc|\.docx|\.xls|\.xlsx|\.pdf)$/i;
          const FileUploadField = $(this.elements.$filepondhidden).find('.m-input-filepond');

          if(FileUploadField.length)
          {
              FileUploadField.each(function ()
              {
                  const UploadField = document.createElement('div');
                  const UploadLabel = document.createElement('label');

                  $(UploadField).addClass('m-uploadfield');
                  UploadLabel.innerHTML = 'Drop or &nbsp;<span>select file</span>';
                  this.append(UploadField);
                  UploadField.append(UploadLabel);
              });

              const input = FileUploadField.find('input');

              input.on('change', (e) =>
              {
                  inputTarget = $(e.target);
                  const Banner = inputTarget.parent().find('.m-file-name-banner');

                  if(Banner)
                  {
                      Banner.remove();
                  }

                  const filePath = inputTarget.val().split(/(\\|\/)/g).pop();
                  const fileNameBanner = document.createElement('div');
                  const fileLabel = document.createElement('div');
                  const buttonCancel = document.createElement('div');
                  const fileSize = document.createElement('div');

                  $(fileSize).html('');

                  fileLabel.innerHTML = filePath;
                  fileNameBanner.append(fileLabel);
                  $(fileLabel).addClass('m-file-label');
                  $(fileNameBanner).addClass('m-file-name-banner');
                  $(buttonCancel).addClass('m-button-filepond');
                  $(fileSize).addClass('m-file-size');
                  const fileSizeData = inputTarget.parent().attr('data-filesize');

                  if (input)
                  {
                      $(fileSize).html(fileSizeData);
                  }

                  if (!allowedExtensions.exec(filePath) || inputTarget.parent().hasClass('is-error'))
                  {
                      $(fileNameBanner).addClass('m-animation-error');
                      $(buttonCancel).addClass('m-cancel-button-error');
                      $(buttonCancel).addClass('is-error');
                  }
                  else
                  {
                      $(fileNameBanner).addClass('m-animation-succes');
                      $(buttonCancel).addClass('m-loading');
                      $(buttonCancel).removeClass('m-cancel-button');
                      setTimeout(() =>
                      {
                          $(buttonCancel).removeClass('m-loading');
                          $(buttonCancel).addClass('m-cancel-button');
                          inputTarget.parent().addClass('is-done');
                          $(fileNameBanner).addClass('m-animation-succes-done');
                      }, '1350');
                  }
                  $(input).each(function (index, element)
                  {
                      if($(element).val().length > 3)
                      {
                          if($(element)[0] === inputTarget[0])
                          {
                              $(element).parent().append(fileNameBanner);
                              fileNameBanner.append(buttonCancel);
                              fileNameBanner.append(fileSize);
                          }
                      }
                  });
              });

              $(document).on('click', (e) =>
              {
                  const buttonTarget = e.target;

                  if($(buttonTarget).hasClass('m-button-filepond'))
                  {
                      $(buttonTarget).parent().addClass('m-animation-cancel');
                      setTimeout(() =>
                      {
                          $(buttonTarget).parent().parent().attr('data-filesize', '');
                          $(buttonTarget).parent().parent().find('input').val('');
                          $(buttonTarget).parent().parent().find('.m-file-name-banner').remove();
                          $(buttonTarget).parent().find('.m-file-size').remove();
                      }, '300');
                  }
              });
          }
      },

  };
